import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import i18n from '../../../common/i18n';
import SectionHeading from './SectionHeading';
import CategoryCard from '../commons/CategoryCard';
import { HELP_CATEGORIES } from '../commons/helpData';

const HelpCategories = ({
  selectedCategory, onSelectCategory, isMobile, showHeading,
}) => (
  <Box component="section">
    {showHeading && (
      <SectionHeading
        eyebrow={i18n.helpTopicsEyebrow}
        title={i18n.helpProducts}
        titleVariant={isMobile ? 'h5' : 'h4'}
        mb={3}
        align="left"
        eyebrowSize={14}
        titleSize={28}
      />
    )}
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      {HELP_CATEGORIES.map((category) => (
        <CategoryCard
          key={category.id}
          title={category.title}
          Icon={category.Icon}
          isMobile={isMobile}
          selected={category.id === selectedCategory}
          onClick={() => onSelectCategory(category.id)}
        />
      ))}
    </Box>
  </Box>
);

HelpCategories.propTypes = {
  selectedCategory: PropTypes.string.isRequired,
  onSelectCategory: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
  showHeading: PropTypes.bool,
};

HelpCategories.defaultProps = {
  isMobile: false,
  showHeading: true,
};

export default HelpCategories;
